import React from 'react';
import { useTable } from '../../context/TableContext.js';

export default function Sidebar() {
  const { state, actions } = useTable();

  const docFormats = [
    { id: 'billing_invoice',          label: 'Billing' },
    { id: 'sales_order',          label: 'Sales Order' },
    { id: 'delivery_note',          label: 'Delivery Note' },
    { id: 'sales_invoice',          label: 'Sales Invoice' },
    { id: 'sales_return',          label: 'Sales Return' },
    { id: 'sales_credit_note',          label: 'Sales Credit Note' },
    { id: 'purchase_order',   label: 'Purchase Order' },
    { id: 'good_receipt_note',              label: 'GRN' },
    { id: 'purchase_invoice', label: 'Purchase Invoice' },
    { id: 'purchase_return', label: 'Purchase Return' },
    { id: 'purchase_credit_note',               label: 'Purchase Credit Note' },
  ];

  const paperTypes = [
    { id: 'a4',     label: 'A4 — 210 × 297 mm (2480×3508 @300dpi)' },
    { id: 'a3',     label: 'A3 — 297 × 420 mm (3508×4961 @300dpi)' },
    { id: 'letter', label: 'Letter — 8.5 × 11 in (2550 x 3300 @300dpi)' },
  ];

  const tableSizes = [
    { id: 'full',           label: 'Full Page' },
    { id: 'three-quarters', label: '3/4 Page' },
    { id: 'half',           label: 'Half Page' },
    { id: 'quarter',        label: '1/4 Page' },
  ];

  const handleTextStyleToggle = (style) => {
    if (!state.selectedCell) return;
    const cellId = state.selectedCell.id;
    const current = state.cells[cellId].styles[style];
    const next =
      style === 'fontWeight'     ? (current === 'bold' ? 'normal' : 'bold') :
      style === 'fontStyle'      ? (current === 'italic' ? 'normal' : 'italic') :
      style === 'textDecoration' ? (current === 'underline' ? 'none' : 'underline') :
      current;
    actions.updateCellStyle(cellId, { [style]: next });
  };

  const handleFontSizeToggle = (size) => {
  if (!state.selectedCell) return;
  const cellId = state.selectedCell.id;

  // current font size (default 12 if missing)
  const current = (Number(state.cells[cellId]?.styles?.fontSize)/20) || 1;

  let next = Number(size);
  if (!Number.isFinite(next)) next = current;
  next = next>5?5:next?next<1:next;
  actions.updateCellStyle(cellId, { fontSize: ((next*20)) });
};

  const incFont = (delta) => {
  if (!state.selectedCell) return;
  const cellId = state.selectedCell.id;
  const current = (Number(state.cells[cellId]?.styles?.fontSize)/20) || 1;
  const expecting_size=current + delta;
  const next = expecting_size>5?5:expecting_size<1?1:expecting_size;
  actions.updateCellStyle(cellId, { fontSize: (next*20) });
};


  const handleAlignmentChange = (alignment) => {
    if (!state.selectedCell) return;
    actions.updateCellStyle(state.selectedCell.id, { textAlign: alignment });
  };

  const handleVerticalAlignmentChange = (alignment) => {
    if (!state.selectedCell) return;
    actions.updateCellStyle(state.selectedCell.id, { verticalAlign: alignment });
  };

  const handleColorChange = (colorType, color) => {
    if (!state.selectedCell) return;
    const styleKey = colorType === 'text' ? 'textColor' : 'backgroundColor';
    actions.updateCellStyle(state.selectedCell.id, { [styleKey]: color });
  };

  const handlePaddingChange = (padding) => {
    if (!state.selectedCell) return;
    actions.updateCellStyle(state.selectedCell.id, { padding: parseInt(padding) });
  };

  return (
    <aside className="w-80 bg-white border-r border-gray-200 overflow-y-auto">
      <div className="p-6 space-y-6">
        {/* ===== Document Format (Type) ===== */}
        <div className="bg-white pb-4 border-b border-EAECF0 z-10">
          <h3 className="text-xlg font-medium text-000000 mb-2">Type</h3>

          <select
            value={state.type}
            onChange={(e) => actions.setType(e.target.value)}
            className="w-full px-3 py-2 rounded-2xl text-sm bg-white text-secondary
                      border border-EAECF0 placeholder-placeholder-color
                      focus:outline-none focus:ring-2 focus:ring-focus-color"
            data-testid="select-document-type"
          >
            {docFormats.map((f) => (
              <option key={f.id} value={f.id}>
                {f.label}
              </option>
            ))}
          </select>
        </div>


        {/* ===== Paper Type ===== */}
        <div>
          <h3 className="text-xlg font-medium text-000000 mb-3">Paper Type</h3>

          <select
            value={state.paperType}
            onChange={(e) => actions.setPaperType(e.target.value)}
            className="w-full px-3 py-2 rounded-2xl text-sm
                      bg-white text-secondary
                      border border-EAECF0
                      placeholder-placeholder-color
                      focus:outline-none focus:ring-2 focus:ring-focus-color"
            data-testid="select-paper-type"
          >
            {paperTypes.map((p) => (
              <option key={p.id} value={p.id}>
                {p.label}
              </option>
            ))}
          </select>
        </div>


        {/* ===== Page Orientation ===== */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">Page Orientation</h3>
          <div className="flex space-x-2">
            <button
              onClick={() => actions.setOrientation("portrait")}
              className={`flex-1 p-3 border-2 rounded-2xl text-sm font-medium flex items-center justify-center space-x-2 transition-colors
                ${
                  state.orientation === "portrait"
                    ? "border-277DFE bg-D5E6Ff text-primary"
                    : "border-EAECF0 hover:border-e6e7eb text-secondary"
                }`}
              data-testid="button-orientation-portrait"
            >
              <i className="fas fa-portrait" />
              <span>Portrait</span>
            </button>

            <button
              onClick={() => actions.setOrientation('landscape')}
              className={`flex-1 p-3 border-2 rounded-2xl text-sm font-medium flex items-center justify-center space-x-2 transition-colors ${
                state.orientation === 'landscape'
                  ? 'border-277DFE bg-D5E6Ff text-primary'
                  : 'border-EAECF0 hover:border-e6e7eb text-secondary'
              }`}
              data-testid="button-orientation-landscape"
            >
              <i className="fas fa-image"></i>
              <span>Landscape</span>
            </button>
          </div>
        </div>

        {/* ===== Printable Size (Table area within page) ===== */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">Printable Size</h3>
          <div className="grid grid-cols-2 gap-2">
            {tableSizes.map((size) => (
              <button
                key={size.id}
                onClick={() => actions.setTableSize(size.id)}
                className={`p-3 border-2 rounded-2xl text-sm font-medium transition-colors ${
                  state.tableSize === size.id
                    ? 'border-277DFE bg-D5E6Ff text-primary'
                    : 'border-EAECF0 hover:border-e6e7eb text-secondary'
                }`}
                data-testid={`button-table-size-${size.id}`}
              >
                {size.label}
              </button>
            ))}
          </div>
        </div>

        {/* ===== Cell Formatting ===== */}
        {state.selectedCell && (
          <div className="border-t pt-6">
            <h3 className="text-lg font-medium text-gray-900 mb-3">Cell Formatting</h3>
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-700 mb-2 block">Font Size (px)</label>
                <div className="mt-6 rounded-xl border border-EAECF0 bg-white p-5">

                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-label-color mb-2">
                        Font Size (px)
                      </label>

                      <div className="inline-flex items-stretch rounded-lg border border-EAECF0 overflow-hidden shadow-sm">
                        <button
                          onClick={() => incFont(-1)}
                          className="px-3 py-2 text-secondary hover:bg-f3f8ff focus:outline-none focus:ring-2 focus:ring-focus-color border-r border-EAECF0 text-sm"
                          data-testid="button-fontsize-dec"
                          aria-label="Decrease font size"
                          type="button"
                        >
                          −
                        </button>

                        <input
                          type="number"
                          min={6}
                          step={1}
                          readOnly
                          value={(Number(state.cells[state.selectedCell.id]?.styles?.fontSize) / 20) || 1}
                          className="w-20 text-center px-3 py-2 bg-white text-000000 text-sm focus:outline-none"
                          data-testid="input-fontsize"
                        />

                        <button
                          onClick={() => incFont(1)}
                          className="px-3 py-2 text-secondary hover:bg-f3f8ff focus:outline-none focus:ring-2 focus:ring-focus-color border-l border-EAECF0 text-sm"
                          data-testid="button-fontsize-inc"
                          aria-label="Increase font size"
                          type="button"
                        >
                          +
                        </button>
                      </div>

                      <p className="mt-2 text-xs text-667085">
                        Use the buttons to adjust the selected cell’s font size.
                      </p>
                    </div>
                  </div>
              </div>
              </div>
            {/* ===== Font Style ===== */}
              <div className="space-y-4">
                <label className="block text-sm font-medium text-label-color mb-2">Text Style</label>

                <div className="inline-flex items-stretch overflow-hidden rounded-lg border border-EAECF0 shadow-sm">
                  {/* Bold */}
                  <button
                    type="button"
                    onClick={() => handleTextStyleToggle("fontWeight")}
                    aria-pressed={state.cells[state.selectedCell.id]?.styles?.fontWeight === "bold"}
                    title="Bold"
                    className={`px-3 py-2 text-sm font-bold focus:outline-none focus:ring-2 focus:ring-focus-color
                      ${
                        state.cells[state.selectedCell.id]?.styles?.fontWeight === "bold"
                          ? "bg-D5E6Ff text-277DFE border-r border-277DFE"
                          : "text-secondary hover:bg-f3f8ff border-r border-EAECF0"
                      }`}
                    data-testid="button-format-bold"
                  >
                    B
                  </button>

                  {/* Italic */}
                  <button
                    type="button"
                    onClick={() => handleTextStyleToggle("fontStyle")}
                    aria-pressed={state.cells[state.selectedCell.id]?.styles?.fontStyle === "italic"}
                    title="Italic"
                    className={`px-3 py-2 text-sm italic focus:outline-none focus:ring-2 focus:ring-focus-color
                      ${
                        state.cells[state.selectedCell.id]?.styles?.fontStyle === "italic"
                          ? "bg-D5E6Ff text-277DFE border-r border-277DFE"
                          : "text-secondary hover:bg-f3f8ff border-r border-EAECF0"
                      }`}
                    data-testid="button-format-italic"
                  >
                    I
                  </button>

                  {/* Underline */}
                  <button
                    type="button"
                    onClick={() => handleTextStyleToggle("textDecoration")}
                    aria-pressed={state.cells[state.selectedCell.id]?.styles?.textDecoration === "underline"}
                    title="Underline"
                    className={`px-3 py-2 text-sm underline focus:outline-none focus:ring-2 focus:ring-focus-color
                      ${
                        state.cells[state.selectedCell.id]?.styles?.textDecoration === "underline"
                          ? "bg-D5E6Ff text-277DFE"
                          : "text-secondary hover:bg-f3f8ff"
                      }`}
                    data-testid="button-format-underline"
                  >
                    U
                  </button>
                </div>
              </div>

            {/* ===== Horizontal Alignment ===== */}
              <div>
                <label className="block text-sm font-medium text-label-color mb-2">
                  Horizontal Alignment
                </label>

                <div className="grid grid-cols-3 gap-1">
                  {/* Left */}
                  <button
                    type="button"
                    onClick={() => handleAlignmentChange("left")}
                    aria-pressed={state.cells[state.selectedCell.id]?.styles?.textAlign === "left"}
                    data-testid="button-align-left"
                    className={`px-3 py-2 rounded-md border text-sm font-medium flex items-center justify-center gap-2
                      ${
                        state.cells[state.selectedCell.id]?.styles?.textAlign === "left"
                          ? "bg-D5E6Ff text-277DFE border-277DFE"
                          : "text-secondary border-EAECF0 hover:bg-f3f8ff"
                      } focus:outline-none focus:ring-2 focus:ring-focus-color`}
                  >
                    <i className="fas fa-align-left text-sm" aria-hidden="true" />
                    <span>Left</span>
                  </button>

                  {/* Center */}
                  <button
                    type="button"
                    onClick={() => handleAlignmentChange("center")}
                    aria-pressed={state.cells[state.selectedCell.id]?.styles?.textAlign === "center"}
                    data-testid="button-align-center"
                    className={`px-3 py-2 rounded-md border text-sm font-medium flex items-center justify-center gap-2
                      ${
                        state.cells[state.selectedCell.id]?.styles?.textAlign === "center"
                          ? "bg-D5E6Ff text-277DFE border-277DFE"
                          : "text-secondary border-EAECF0 hover:bg-f3f8ff"
                      } focus:outline-none focus:ring-2 focus:ring-focus-color`}
                  >
                    <i className="fas fa-align-center text-sm" aria-hidden="true" />
                    <span>Center</span>
                  </button>

                  {/* Right */}
                  <button
                    type="button"
                    onClick={() => handleAlignmentChange("right")}
                    aria-pressed={state.cells[state.selectedCell.id]?.styles?.textAlign === "right"}
                    data-testid="button-align-right"
                    className={`px-3 py-2 rounded-md border text-sm font-medium flex items-center justify-center gap-2
                      ${
                        state.cells[state.selectedCell.id]?.styles?.textAlign === "right"
                          ? "bg-D5E6Ff text-277DFE border-277DFE"
                          : "text-secondary border-EAECF0 hover:bg-f3f8ff"
                      } focus:outline-none focus:ring-2 focus:ring-focus-color`}
                  >
                    <i className="fas fa-align-right text-sm" aria-hidden="true" />
                    <span>Right</span>
                  </button>
                </div>
              </div>

            {/* ===== Vertical Alignment ===== */}
              <div>
                <label className="block text-sm font-medium text-label-color mb-2">
                  Vertical Alignment
                </label>

                <div className="grid grid-cols-3 gap-1">
                  <button
                    type="button"
                    onClick={() => handleVerticalAlignmentChange("top")}
                    aria-pressed={state.cells[state.selectedCell.id]?.styles?.verticalAlign === "top"}
                    data-testid="button-valign-top"
                    className={`px-3 py-2 rounded-md border text-xs font-medium flex items-center justify-center
                      ${
                        state.cells[state.selectedCell.id]?.styles?.verticalAlign === "top"
                          ? "bg-D5E6Ff text-277DFE border-277DFE"
                          : "text-secondary border-EAECF0 hover:bg-f3f8ff"
                      } focus:outline-none focus:ring-2 focus:ring-focus-color`}
                  >
                    Top
                  </button>
                  <button
                    type="button"
                    onClick={() => handleVerticalAlignmentChange("middle")}
                    aria-pressed={state.cells[state.selectedCell.id]?.styles?.verticalAlign === "middle"}
                    data-testid="button-valign-middle"
                    className={`px-3 py-2 rounded-md border text-xs font-medium flex items-center justify-center
                      ${
                        state.cells[state.selectedCell.id]?.styles?.verticalAlign === "middle"
                          ? "bg-D5E6Ff text-277DFE border-277DFE"
                          : "text-secondary border-EAECF0 hover:bg-f3f8ff"
                      } focus:outline-none focus:ring-2 focus:ring-focus-color`}
                  >
                    Middle
                  </button>

                  <button
                    type="button"
                    onClick={() => handleVerticalAlignmentChange("bottom")}
                    aria-pressed={state.cells[state.selectedCell.id]?.styles?.verticalAlign === "bottom"}
                    data-testid="button-valign-bottom"
                    className={`px-3 py-2 rounded-md border text-xs font-medium flex items-center justify-center
                      ${
                        state.cells[state.selectedCell.id]?.styles?.verticalAlign === "bottom"
                          ? "bg-D5E6Ff text-277DFE border-277DFE"
                          : "text-secondary border-EAECF0 hover:bg-f3f8ff"
                      } focus:outline-none focus:ring-2 focus:ring-focus-color`}
                  >
                    Bottom
                  </button>
                </div>
              </div>

            
            {/* ===== Color Selection ===== */}
              <div>
                <label className="block text-sm font-medium text-label-color mb-2">Colors</label>

                <div className="space-y-3">
                  {/* Text color */}
                  <div className="flex items-center gap-3">
                    <span className="text-xs text-667085 w-20">Text</span>
                    <input
                      type="color"
                      value={state.cells[state.selectedCell.id]?.styles.textColor || "#000000"}
                      onChange={(e) => handleColorChange("text", e.target.value)}
                      className="w-9 h-9 rounded-md border border-EAECF0 cursor-pointer p-0
                                focus:outline-none focus:ring-2 focus:ring-focus-color"
                      data-testid="input-text-color"
                      aria-label="Text color"
                    />
                    <span className="text-xs text-value-color">
                      {state.cells[state.selectedCell.id]?.styles.textColor || "#000000"}
                    </span>
                  </div>

                  {/* Background color */}
                  <div className="flex items-center gap-3">
                    <span className="text-xs text-667085 w-20">Background</span>
                    <input
                      type="color"
                      value={state.cells[state.selectedCell.id]?.styles.backgroundColor || "#ffffff"}
                      onChange={(e) => handleColorChange("background", e.target.value)}
                      className="w-9 h-9 rounded-md border border-EAECF0 cursor-pointer p-0
                                focus:outline-none focus:ring-2 focus:ring-focus-color"
                      data-testid="input-background-color"
                      aria-label="Background color"
                    />
                    <span className="text-xs text-value-color">
                      {state.cells[state.selectedCell.id]?.styles.backgroundColor || "#ffffff"}
                    </span>
                  </div>
                </div>
              </div>


              {/* Padding slider spot if needed */}
            </div>
          </div>
        )}

        {/* ===== Cell Operations ===== */}
        {state.selectedCell && (
          <div className="border-t border-EAECF0 pt-6">
            <h3 className="text-xlg font-semibold text-000000 mb-3">Cell Operations</h3>

            <div className="space-y-2">
              {/* Merge (pastel blue) */}
              <button
                onClick={actions.mergeRight}
                className="w-full px-3 py-2 rounded text-sm font-medium text-277DFE bg-D5E6Ff"
                data-testid="button-merge-cells-right"
                type="button"
              >
                Merge Cells Horizontal
              </button>

              <button
                onClick={actions.mergeDown}
                className="w-full px-3 py-2 rounded text-sm font-medium text-277DFE bg-D5E6Ff"
                data-testid="button-merge-cells-down"
                type="button"
              >
                Merge Cells Vertical
              </button>

              {/* Split (pastel amber) — disabled look */}
              <button
                onClick={actions.splitCell}
                disabled={
                  !state.cells[state.selectedCell.id]?.colspan ||
                  state.cells[state.selectedCell.id]?.colspan <= 1
                }
                className="w-full px-3 py-2 rounded text-sm font-medium
                          text-FFBA08 text-reports-shade3_text bg-reports-shade3_bg disabled:opacity-100 disabled:cursor-not-allowed disabled:bg-disabled-color disabled:text-F4F4F4"
                data-testid="button-split-cell"
                type="button"
              >
                Split Horizontal
              </button>

              <button
                onClick={actions.splitCellDown}
                disabled={
                  !state.cells[state.selectedCell.id]?.rowspan ||
                  state.cells[state.selectedCell.id]?.rowspan <= 1
                }
                className="w-full px-3 py-2 rounded text-sm font-medium
                          text-FFBA08 text-reports-shade3_text bg-reports-shade3_bg disabled:opacity-100 disabled:cursor-not-allowed disabled:bg-disabled-color disabled:text-F4F4F4"
                data-testid="button-split-cell-down"
                type="button"
              >
                Split Vertical
              </button>

              {/* Add (pastel green) */}
              <button
                onClick={actions.addProductTable}
                disabled={state.addedTable}
                className="w-full px-3 py-2 rounded text-sm font-medium
                          text-027A48 text-reports-shade4_text bg-reports-shade4_bg disabled:opacity-100 disabled:cursor-not-allowed disabled:bg-disabled-color disabled:text-F4F4F4"
                data-testid="button-add-product-table"
                type="button"
              >
                Add Product Table
              </button>

              {/* Delete (pastel red) — disabled look */}
              <button
                onClick={actions.deleteProductTable}
                disabled={
                  !state.addedTable ||
                  !state.selectedCell ||
                  !state.cells[state.selectedCell.id]?.productTable
                }
                className="w-full px-3 py-2 rounded text-sm font-medium
                          text-reports-shade6_text bg-reports-shade6_bg  disabled:opacity-100 disabled:cursor-not-allowed disabled:bg-disabled-color disabled:text-F4F4F4"
                data-testid="button-delete-product-table"
                type="button"
              >
                Delete Product Table
              </button>

              {/* Toggles (light gray) */}
              <button
                onClick={actions.toggleHeaderRow}
                className="w-full px-3 py-2 rounded text-sm font-medium
                          text-secondary bg-f3f4f6"
                data-testid="button-toggle-header"
                type="button"
              >
                Toggle Header
              </button>

              <button
                onClick={actions.toggleFooterRow}
                className="w-full px-3 py-2 rounded text-sm font-medium
                          text-secondary bg-f3f4f6"
                data-testid="button-toggle-footer"
                type="button"
              >
                Toggle Footer
              </button>
            </div>
          </div>
        )}


      </div>
    </aside>
  );
}
